import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import CookieConsent from "@/components/layout/CookieConsent";
import ChatBot from "@/components/chat/ChatBot";
import HomePage from "@/pages/HomePage";
import CityPage from "@/pages/CityPage";
import ComparePage from "@/pages/ComparePage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import AllCitiesPage from "@/pages/AllCitiesPage";
import AdminPage from "@/pages/AdminPage";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import NotFoundPage from "@/pages/NotFoundPage";
import "@/App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AccessibilityWidget />
      <div id="main-wrapper" className="min-h-screen flex flex-col bg-white text-gray-900">
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={
            <>
              <Navbar />
              <main id="main-content" className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/storage/:slug" element={<CityPage type="storage" />} />
                  <Route path="/parking/:slug" element={<CityPage type="parking" />} />
                  <Route path="/moving/:slug" element={<CityPage type="moving" />} />
                  <Route path="/compare" element={<ComparePage />} />
                  <Route path="/all-cities" element={<AllCitiesPage />} />
                  <Route path="/blog" element={<BlogListPage />} />
                  <Route path="/blog/:slug" element={<BlogPostPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/cookie-policy" element={<CookiePolicyPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>
              <Footer />
              <ChatBot />
              <CookieConsent />
            </>
          } />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
